import { createApp } from 'vue';
import GetTalentReportForm from '../../../career/GetTlntReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-career-form-view')
Array.from(appElements).forEach(element => {
    createApp(GetTalentReportForm).mount(element);
});